export interface BlogArticleMeta {
  tag: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  slug: string;
}

export const ARTICLES: BlogArticleMeta[] = [
  {
    tag: "Frontalieri",
    title: "Frontalieri Italia-Svizzera 2026: nuovo accordo fiscale e imposizione dei redditi",
    excerpt: "Il nuovo accordo in vigore dal 17 luglio 2023 ha cambiato tutto: 80% imposta alla fonte in Svizzera, dichiarazione in Italia con credito d'imposta, franchigia EUR 10'000. Guida operativa per frontalieri vecchi e nuovi.",
    date: "Aprile 2026",
    readTime: "11 min",
    slug: "/blog/frontalieri-italia-svizzera-2026",
  },
  {
    tag: "Confronto cantoni",
    title: "Ticino vs Zugo, Grigioni, Svitto: dove aprire sede aziendale in Svizzera",
    excerpt: "Confronto reale tra cantoni svizzeri a basso carico fiscale 2026: aliquote effettive sull'utile, costi operativi, lingua, logistica. Ticino conviene ancora per PMI italofone? Numeri alla mano.",
    date: "Aprile 2026",
    readTime: "12 min",
    slug: "/blog/dove-aprire-sede-aziendale-svizzera-confronto-cantoni",
  },
  {
    tag: "Forma societaria",
    title: "SA vs Sagl in Ticino: quale forma societaria scegliere nel 2026",
    excerpt: "CHF 100'000 per SA, CHF 20'000 per Sagl: ma non è solo capitale. Governance, riservatezza, fiscalità, costi annuali e trasferibilità delle quote. Confronto completo con casi reali ticinesi.",
    date: "Aprile 2026",
    readTime: "10 min",
    slug: "/blog/sa-vs-sagl-ticino-2026",
  },
  {
    tag: "Trasloco fiscale",
    title: "Trasferirsi in Ticino dall'Italia: fiscalità, permessi e pratiche 2026",
    excerpt: "Permesso B o L, notifica d'arrivo, iscrizione AVS, chiusura fiscale italiana con exit tax: la guida operativa completa per chi sposta residenza e reddito dall'Italia al Ticino nel 2026.",
    date: "Aprile 2026",
    readTime: "11 min",
    slug: "/blog/trasferirsi-in-ticino-dall-italia-2026",
  },
  {
    tag: "Guida IVA",
    title: "IVA Svizzera 2026 per PMI ticinesi: aliquote, soglie, registrazione",
    excerpt: "Aliquote IVA 2026 in vigore: 8.1% normale, 2.6% ridotta, 3.8% alloggio. Soglia CHF 100'000, rendiconto trimestrale, metodo effettivo vs saldo. Tutto quello che serve sapere in Canton Ticino.",
    date: "Aprile 2026",
    readTime: "9 min",
    slug: "/blog/iva-svizzera-2026-pmi-ticino",
  },
  {
    tag: "Scadenze",
    title: "Chiusura fiscale 2026 in Ticino: scadenze, documenti, checklist",
    excerpt: "Dichiarazione 2026 in TI: scadenza 31 marzo 2027, proroga settembre, moduli 1-16, documenti bancari, spese deducibili. Checklist operativa per privati, autonomi e PMI ticinesi.",
    date: "Aprile 2026",
    readTime: "8 min",
    slug: "/blog/chiusura-fiscale-2026-ticino-checklist",
  },
  {
    tag: "Previdenza",
    title: "3° pilastro A 2026: limiti di deduzione per dipendenti e autonomi",
    excerpt: "Nel 2026 il dipendente con LPP deduce max CHF 7'258; l'autonomo senza cassa pensione arriva a CHF 36'288 (20% del reddito netto). Tutti i dettagli, regole di prelievo e risparmio fiscale reale.",
    date: "Aprile 2026",
    readTime: "8 min",
    slug: "/blog/terzo-pilastro-a-2026-limiti-deduzione",
  },
  {
    tag: "Previdenza",
    title: "AVS, AI, IPG 2026 per lavoratori autonomi in Ticino: contributi e scaglioni",
    excerpt: "Aliquota piena 10.00% sopra CHF 60'500 di reddito, contributo minimo CHF 530/anno. Come funzionano acconti, conguaglio e dichiarazione annuale per ditte individuali e freelancer in TI.",
    date: "Aprile 2026",
    readTime: "9 min",
    slug: "/blog/avs-ai-ipg-autonomi-ticino-2026",
  },
  {
    tag: "Guida fiscale",
    title: "Deduzioni fiscali Ticino 2026: come pagare meno tasse legalmente",
    excerpt: "Terzo pilastro, AVS, home office, spese professionali: tutte le deduzioni disponibili in Canton Ticino per ridurre il reddito imponibile e risparmiare migliaia di franchi ogni anno.",
    date: "Aprile 2026",
    readTime: "10 min",
    slug: "/blog/deduzioni-fiscali-ticino-2026",
  },
  {
    tag: "Per freelancer",
    title: "Cosa si può scaricare dalle tasse in Svizzera: guida 2026 per freelancer",
    excerpt: "Laptop, telefono, home office, software, formazione: tutto quello che puoi dedurre come freelancer o lavoratore indipendente in Svizzera. Con esempi e importi concreti.",
    date: "Aprile 2026",
    readTime: "9 min",
    slug: "/blog/spese-deducibili-freelancer-svizzera",
  },
  {
    tag: "Dati fiscali",
    title: "Aliquote fiscali Canton Ticino 2026: quanto si paga davvero",
    excerpt: "Tabelle complete delle aliquote fiscali in Ticino 2026: imposta federale, cantonale e moltiplicatori comunali. Esempi pratici per redditi da CHF 40'000 a CHF 200'000.",
    date: "Aprile 2026",
    readTime: "8 min",
    slug: "/blog/aliquote-fiscali-ticino-2026",
  },
  {
    tag: "Guida pratica",
    title: "Come aprire una ditta individuale in Ticino: guida completa 2026",
    excerpt: "Tutti i passi necessari per aprire una ditta individuale nel Canton Ticino: dalla registrazione al RC, passando per AVS, IVA e gli obblighi fiscali.",
    date: "Marzo 2026",
    readTime: "8 min",
    slug: "/blog/aprire-ditta-individuale-ticino",
  },
  {
    tag: "Confronto",
    title: "Quanto costa un fiduciario in Ticino nel 2026?",
    excerpt: "Tariffe orarie, costi annuali e alternative digitali: tutto quello che devi sapere prima di scegliere un fiduciario in Ticino. Con confronto tra modello tradizionale e piattaforme online.",
    date: "Marzo 2026",
    readTime: "6 min",
    slug: "/blog/quanto-costa-fiduciario-ticino",
  },
  {
    tag: "Famiglia",
    title: "Trasferirsi in Ticino con figli 2026: scuole, asili, famiglia",
    excerpt: "Permessi, scuole pubbliche e private, asili nido, sanità, costi, deduzioni famigliari: timeline completa 6 mesi prima → 3 mesi dopo per famiglie che si trasferiscono dall'Italia con bambini.",
    date: "Aprile 2026",
    readTime: "11 min",
    slug: "/blog/trasferirsi-ticino-con-figli-2026",
  },
  {
    tag: "Banche",
    title: "Aprire un conto bancario in Svizzera 2026: PostFinance, UBS, banche cantonali e digitali",
    excerpt: "PostFinance, UBS, BancaStato, Migros Bank, Yuh, Neon, Revolut: confronto, costi, documentazione e strategia per nuovi residenti e PMI in Ticino. Apertura, tempi, multivaluta.",
    date: "Aprile 2026",
    readTime: "8 min",
    slug: "/blog/aprire-conto-bancario-svizzera-2026",
  },
  {
    tag: "Lavoro autonomo",
    title: "Lavorare da casa autonomi in Ticino 2026: setup, ergonomia, deduzioni fiscali",
    excerpt: "Forfait vs spese effettive home office, setup ergonomico (sedia, scrivania, monitor), deduzioni complete per freelance ticinesi. Connettività, ROI ergonomia, ottimizzazioni fiscali specifiche.",
    date: "Aprile 2026",
    readTime: "9 min",
    slug: "/blog/lavoro-autonomo-da-casa-ticino-2026",
  },
  {
    tag: "Lifestyle",
    title: "Costo della vita Ticino vs Italia 2026: il confronto reale",
    excerpt: "Affitti, spesa, sanità, scuole, tasse: confronto dettagliato tra costo vita in Ticino e in Italia (Milano, Como, Varese) per decidere se conviene trasferirsi. Numeri reali per profilo familiare.",
    date: "Aprile 2026",
    readTime: "10 min",
    slug: "/blog/costo-vita-ticino-vs-italia-2026",
  },
  {
    tag: "Sanità",
    title: "Sanità in Svizzera per nuovi residenti 2026: LAMal, casse malati, scelta giusta",
    excerpt: "Come scegliere la cassa malati LAMal in Ticino: confronto Helsana, Sympany, CSS, Concordia, franchigie, modelli alternativi, sussidio cantonale, LCA complementare per nuovi residenti.",
    date: "Aprile 2026",
    readTime: "9 min",
    slug: "/blog/sanita-svizzera-nuovi-residenti-2026",
  },
  {
    tag: "Previdenza",
    title: "Pianificare la pensione a 40 anni in Svizzera: strategia 1°+2°+3° pilastro",
    excerpt: "Strategia previdenziale completa per chi ha 40 anni: AVS, LPP, 3° pilastro A multipli, riscatti volontari, ammortamento indiretto. Risparmio fiscale e patrimonio costruito a 65 anni.",
    date: "Aprile 2026",
    readTime: "12 min",
    slug: "/blog/pianificare-pensione-40-anni-svizzera",
  },
  {
    tag: "Successioni",
    title: "Donazioni e successioni in Ticino 2026: pianificare il trasferimento del patrimonio",
    excerpt: "Imposte successione TI, donazioni esenti, quote legittime, testamento, patti successori. Strategia per famiglie e per imprenditori con casi pratici e costi notarili.",
    date: "Aprile 2026",
    readTime: "10 min",
    slug: "/blog/donazioni-successioni-ticino-2026",
  },
  {
    tag: "Guida pratica",
    title: "Primo colloquio con il fiduciario: checklist completa per non sbagliare",
    excerpt: "Cosa portare, cosa chiedere, come prepararsi al primo colloquio con un fiduciario. Documenti, domande chiave, red flag, mindset corretto, costi tipici di mercato 2026.",
    date: "Aprile 2026",
    readTime: "6 min",
    slug: "/blog/primo-colloquio-fiduciario-checklist",
  },
  {
    tag: "Fatturazione",
    title: "QR-Bill e fatturazione elettronica in Svizzera 2026: standard, obblighi, tools",
    excerpt: "Guida pratica QR-Bill e standard eCH per fatturazione svizzera 2026. QRR, SCOR, riconciliazione automatica camt.053, GeBüV WORM, confronto con fattura elettronica italiana SDI.",
    date: "Aprile 2026",
    readTime: "9 min",
    slug: "/blog/qr-bill-fatturazione-elettronica-svizzera-2026",
  },
  {
    tag: "Lifestyle",
    title: "Diventare nomade digitale dalla Svizzera 2026: visti, fiscalità, base operativa",
    excerpt: "Come strutturare la vita da nomade digitale mantenendo base in Svizzera: residenza fiscale, visti per Portogallo/Spagna/UAE/Bali, fatturazione cross-border, banche multivaluta, salute internazionale.",
    date: "Aprile 2026",
    readTime: "11 min",
    slug: "/blog/nomade-digitale-svizzera-2026",
  },
];

// Module-level Maps built once at load time — O(1) slug lookup, O(1) tag lookup.
const ARTICLES_BY_SLUG = new Map<string, BlogArticleMeta>(
  ARTICLES.map((a) => [a.slug, a]),
);

const ARTICLES_BY_TAG = ARTICLES.reduce<Map<string, BlogArticleMeta[]>>(
  (acc, a) => {
    const bucket = acc.get(a.tag);
    if (bucket) {
      bucket.push(a);
    } else {
      acc.set(a.tag, [a]);
    }
    return acc;
  },
  new Map(),
);

export function getRelatedArticles(currentSlug: string, count = 3): BlogArticleMeta[] {
  const current = ARTICLES_BY_SLUG.get(currentSlug);
  if (!current) return [];
  // Same-tag articles first (preserves previous priority ordering).
  const sameTag = (ARTICLES_BY_TAG.get(current.tag) ?? []).filter(
    (a) => a.slug !== currentSlug,
  );
  const others = ARTICLES.filter(
    (a) => a.slug !== currentSlug && a.tag !== current.tag,
  );
  return [...sameTag, ...others].slice(0, count);
}
